export default __webpack_public_path__ + "static/media/icn-dashboard.a12ce0aa.svg";